import {
  DueDisplayOptions,
  ExternalCalendarEvent,
  GoalDeadlineRowsMap,
  ID,
  Task,
  TimeFormatOptions,
} from '@griply/types';
import { createContext, useContext } from 'react';

export type UpcomingDeadlineRenderData = {
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  overdueTasks: Task[];
  externalEvents?: ExternalCalendarEvent[];
  today: Date;
  denseFormat?: boolean;
  displayDue?: DueDisplayOptions[];
  timeFormat?: TimeFormatOptions;
  showCompleted?: boolean;
  goalRenderData?: GoalDeadlineRowsMap;
};

export const UpcomingDeadlineRenderDataContext =
  createContext<UpcomingDeadlineRenderData | null>(null);

export const useUpcomingDeadlineRenderData = (): UpcomingDeadlineRenderData => {
  const data = useContext(UpcomingDeadlineRenderDataContext);
  if (!data) {
    throw new Error(
      'useUpcomingDeadlineRenderData must be used within an UpcomingDeadlineGroupingTasksList',
    );
  }
  return data;
};
